/**
 * WorkflowConditionDialog - Modal de edição dos filtros do Workflow 2.0
 *
 * O sheet do inspetor é estreito demais para conjuntos de regras. Por isso o
 * padrão adotado é: no sheet fica o RESUMO (`WorkflowConditionSummary`) e a
 * edição acontece neste modal amplo, com espaço para vários conjuntos.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-01 v1.0.0 - Criação inicial (filtros robustos do gatilho)
 */

import { useEffect, useState } from 'react';
import { Filter } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { WorkflowDialogShell } from '../WorkflowDialogShell';
import {
  WorkflowConditionBuilder,
  normalizarCondicao,
  serializarCondicao,
  type CondicaoWorkflow,
} from './WorkflowConditionBuilder';

interface Props {
  open: boolean;
  onOpenChange: (aberto: boolean) => void;
  /** Condição atual (qualquer formato aceito por `normalizarCondicao`) */
  valor: unknown;
  onSalvar: (condicao: CondicaoWorkflow) => void;
  title?: string;
  description?: string;
  /** Entidade-raiz do processo (crm_deal | billing). Padrão: Negócio */
  entidade?: string | null;
}

export function WorkflowConditionDialog({
  open,
  onOpenChange,
  valor,
  onSalvar,
  title = 'Configurar filtros',
  entidade,
  description = 'Monte conjuntos de regras combinando E / OU. O processo só continua quando o resultado for verdadeiro.',
}: Props) {
  const [rascunho, setRascunho] = useState<CondicaoWorkflow>(normalizarCondicao(valor));

  // Reabrir o modal sempre parte do valor gravado (descarta rascunho anterior)
  useEffect(() => {
    if (open) setRascunho(normalizarCondicao(valor));
  }, [open, valor]);

  return (
    <WorkflowDialogShell
      open={open}
      onOpenChange={onOpenChange}
      icon={Filter}
      title={title}
      description={description}
      maxWidthClass="sm:max-w-3xl"
      footer={
        <>
          <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            size="sm"
            onClick={() => {
              onSalvar(serializarCondicao(rascunho));
              onOpenChange(false);
            }}
          >
            Aplicar filtros
          </Button>
        </>
      }
    >
      <WorkflowConditionBuilder valor={rascunho} onChange={setRascunho} titulo="" semMoldura entidade={entidade} />
    </WorkflowDialogShell>
  );
}
